module.exports = __webpack_public_path__ + "img/765.739c0b73.gif";